if (!customElements.get('panel-calculator')) {
  class PanelCalculator extends HTMLElement {
    connectedCallback() {
      this.toolEl = this.querySelector('.panel-calc__tool');
      this.widthInput = this.querySelector('.panel-calc__width');
      this.heightInput = this.querySelector('.panel-calc__height');
      this.formatInputs = this.querySelectorAll('input[name="panel-format"]');
      this.productSelect = this.querySelector('.panel-calc__product');
      this.variantSelect = this.querySelector('.panel-calc__variant');
      this.countEl = this.querySelector('.panel-calc__count');
      this.areaEl = this.querySelector('.panel-calc__area');
      this.wasteEl = this.querySelector('.panel-calc__waste-area');
      this.costRow = this.querySelector('.panel-calc__cost');
      this.costEl = this.querySelector('.panel-calc__cost-value');
      this.linkRow = this.querySelector('.panel-calc__link');
      this.linkEl = this.querySelector('.panel-calc__product-link');
      this.products = [];
      this.displayedCount = 0;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      const dataEl = this.querySelector('.panel-calc__data');
      if (dataEl) {
        try {
          this.products = JSON.parse(dataEl.textContent);
        } catch (e) {
          console.error('[wvh] panel-calc: failed to parse product data', e);
        }
      }

      const recalc = this.calculate.bind(this);
      if (this.widthInput) this.widthInput.addEventListener('input', recalc);
      if (this.heightInput) this.heightInput.addEventListener('input', recalc);
      this.formatInputs.forEach((input) => input.addEventListener('change', recalc));

      if (this.productSelect && this.products.length) {
        this.products.forEach((product, index) => {
          const option = document.createElement('option');
          option.value = index;
          option.textContent = product.title;
          this.productSelect.appendChild(option);
        });
        this.productSelect.addEventListener('change', () => {
          this.populateVariants();
          this.calculate();
        });
        this.variantSelect.addEventListener('change', recalc);
        this.populateVariants();
      }
    }

    populateVariants() {
      const product = this.products[parseInt(this.productSelect.value, 10)];
      this.variantSelect.innerHTML = '';
      if (!product) return;
      product.variants.forEach((variant, index) => {
        const option = document.createElement('option');
        option.value = index;
        option.textContent = variant.title === 'Default Title' ? 'Standard' : variant.title;
        this.variantSelect.appendChild(option);
      });
      this.variantSelect.closest('.panel-calc__field').hidden = product.variants.length < 2;
    }

    selection() {
      if (this.productSelect && this.products.length) {
        const product = this.products[parseInt(this.productSelect.value, 10)];
        if (!product) return null;
        const variant = product.variants[parseInt(this.variantSelect.value, 10) || 0];
        if (!variant) return null;
        return { coverage: variant.coverage, price: variant.price, url: product.url };
      }
      let chosen = null;
      this.formatInputs.forEach((input) => {
        if (input.checked) chosen = input;
      });
      if (!chosen) return null;
      return { coverage: parseFloat(chosen.dataset.coverage), price: parseFloat(chosen.dataset.price) || 0, url: null };
    }

    showCount(target) {
      if (this.reducedMotion.matches || Math.abs(target - this.displayedCount) < 2) {
        this.countEl.textContent = target;
        this.displayedCount = target;
        return;
      }
      const start = this.displayedCount;
      const startTime = performance.now();
      const duration = 240;
      const step = (now) => {
        const t = Math.min((now - startTime) / duration, 1);
        const eased = 1 - Math.pow(1 - t, 2);
        const value = Math.round(start + (target - start) * eased);
        this.countEl.textContent = value;
        if (t < 1) {
          requestAnimationFrame(step);
        } else {
          this.displayedCount = target;
        }
      };
      requestAnimationFrame(step);
    }

    calculate() {
      const w = parseFloat(this.widthInput.value);
      const h = parseFloat(this.heightInput.value);
      const selected = this.selection();
      const coverage = selected ? selected.coverage : 0;

      if (!w || !h || w <= 0 || h <= 0 || !coverage) {
        if (this.toolEl) this.toolEl.classList.remove('is-live');
        return;
      }

      const area = w * h;
      const withWaste = area * 1.1;
      const panels = Math.ceil(withWaste / coverage);

      this.showCount(panels);
      this.areaEl.textContent = area.toFixed(1);
      this.wasteEl.textContent = withWaste.toFixed(1);

      if (this.costRow && this.costEl) {
        if (selected.price > 0) {
          const cost = panels * selected.price;
          this.costEl.textContent = cost.toLocaleString('en-GB', { style: 'currency', currency: 'GBP', maximumFractionDigits: 0 });
          this.costRow.hidden = false;
        } else {
          this.costRow.hidden = true;
        }
      }

      if (this.linkRow && this.linkEl) {
        if (selected.url) {
          this.linkEl.href = selected.url;
          this.linkRow.hidden = false;
        } else {
          this.linkRow.hidden = true;
        }
      }

      if (this.toolEl) this.toolEl.classList.add('is-live');
    }
  }
  customElements.define('panel-calculator', PanelCalculator);
}
